export class ContinentDto {
    ContinentName:string;
    SubscriberId: string;
    id: string;
    SiteId: string;
    ModifiedById: string;
    CreatedById: string;
    dateUpdated: Date;
    dateCreated: Date
    Version: Number;
}
